import React from 'react';
import { Box } from '@mui/material';

import { TimeSettingsPreset } from './presets/timeSettingsPresets';

import { Icon } from '@liftango/ui-icons';
import { ICON_FALLBACKS } from '../../../utils/iconFallbacks';
interface PresetParameterPreviewProps {
  preset: TimeSettingsPreset;
  selected?: boolean;
  width?: number;
  height?: number;
}

const PresetParameterPreview: React.FC<PresetParameterPreviewProps> = ({
  preset,
  selected = false,
  width = 80,
  height = 40
}) => {
  const getIcon = () => {
    const iconProps = {
      sx: { 
        fontSize: 24,
        color: selected ? '#ff9800' : '#666'
      }
    };

    switch (preset.id) {
      case 'ride-hailing':
        return <Icon size={20} name="car-side" {...iconProps} />;
      case 'paratransit':
        return <Icon size={20} name="wheelchair-move" {...iconProps} />;
      case 'rural':
        return <Icon size={20} d={ICON_FALLBACKS.Landscape} {...iconProps} />;
      case 'manual':
        return <Icon size={20} name="gear" {...iconProps} />;
      default:
        return <Icon size={20} name="gear" {...iconProps} />;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: width,
        height: height,
        border: selected ? '2px solid #ff9800' : '1px solid #e0e0e0',
        borderRadius: 1,
        backgroundColor: selected ? '#fff3e0' : '#fafafa',
        transition: 'all 0.2s ease-in-out'
      }}
    >
      {getIcon()}
    </Box>
  );
};

export default PresetParameterPreview; 